import { Link } from "react-router-dom";
import "./styles/NotFoundPage.css";

export function NotFoundPage() {
  return (
    <div className="section not-found container">
      <p className="eyebrow">404</p>
      <h1 className="section__title">We couldn't find that page</h1>
      <p className="section__lead">It may have moved, or the link might be mistyped.</p>
      <Link to="/" className="btn btn--primary not-found__button">Back to the home page</Link>
    </div>
  );
}
